module.exports = __webpack_public_path__ + "static/media/column-swap-step2.d7ec9936.svg";